<template>
  <q-dialog v-model="display">
    <q-card>
      <q-card-section>
        <div class="camera-frame q-pa-md">
          <video
            ref="video"
            autoplay
            class="full-width"
            v-show="!imageCaptured"
          />
          <canvas
            ref="canvas"
            class="full-width"
            height="240"
            v-show="imageCaptured"
          />
        </div>
        <div class="text-center q-pa-md">
          <q-btn round color="black" icon="fa fa-camera" size="lg" @click="captureImage" v-if="!imageCaptured && hasCameraSupport"/>
          <q-btn round outline color="black" icon="fa fa-refresh" size="lg" @click="resetCamera" v-else/>
        </div>
      </q-card-section>
      <q-separator />
      <q-card-actions align="between">
        <q-btn flat label="Cancel" color="primary" v-close-popup />
        <q-btn label="Use photo" color="primary" v-close-popup @click="usePhoto"/>
      </q-card-actions>
    </q-card>
  </q-dialog>
</template>
<script>

require('md-gum-polyfill')

export default {
  name: 'OpenCamera',
  model: {
    prop: 'show',
    event: 'change'
  },
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    display: {
      get: function () {
        return this.show
      },
      set: function (value) {
        this.$emit('change', value)
      }
    }
  },
  data () {
    return {
      image: null,
      imageCaptured: false,
      hasCameraSupport: true
    }
  },
  methods: {
    initCamera () {
      this.imageCaptured = false
      navigator.mediaDevices.getUserMedia({
        video: { facingMode: 'environment' }
      }).then(stream => {
        this.$refs.video.srcObject = stream
      }).catch(() => {
        this.hasCameraSupport = false
      })
    },
    disableCamera () {
      this.$refs.video.srcObject.getVideoTracks().forEach(track => track.stop())
    },
    captureImage () {
      const video = this.$refs.video
      const canvas = this.$refs.canvas

      canvas.width = video.getBoundingClientRect().width * 5
      canvas.height = video.getBoundingClientRect().height * 5
      const context = canvas.getContext('2d')
      context.drawImage(video, 0, 0, canvas.width, canvas.height)
      this.imageCaptured = true
      const blob = this.dataURItoBlob(canvas.toDataURL('image/jpeg', 1))
      const imageName = 'image_' + (100000000 * Math.random()).toFixed(0) + '.jpg'
      this.image = new File([blob], imageName, {
        type: blob.type
      })
    },
    dataURItoBlob (dataURI) {
      let byteString

      if (dataURI.split(',')[0].indexOf('base64') >= 0) {
        byteString = atob(dataURI.split(',')[1])
      } else {
        byteString = encodeURI(dataURI.split(',')[1])
      }
      // separate out the mime component
      const mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0]

      // write the bytes of the string to a typed array
      const ia = new Uint8Array(byteString.length)
      for (let i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i)
      }

      return new Blob([ia], { type: mimeString })
    },
    usePhoto () {
      if (!this.imageCaptured) {
        this.captureImage()
      }
      this.$emit('captured', this.image)
    },
    resetCamera () {
      this.imageCaptured = false
    }
  },
  beforeDestroy () {
    if (this.show) {
      this.disableCamera()
    }
  },
  mounted () {
    if (this.show) {
      this.initCamera()
    }
  },
  components: {}
}
</script>
<style lang="sass" scoped>
.camera-frame
  border: 2px solid #333333
  border-radius: 10px
</style>
